import React from 'react';
import { SectionLabel } from './ui/Reveal';
import { clientLogos, stats } from '../data/site';

/** Premium, uncrowded client wall. Add entries in data/site.ts → clientLogos. */
export function ClientLogos() {
  const remaining = Math.max(0, stats[0].value - clientLogos.length);
  return <section className="bg-surface py-16 sm:py-20" aria-label="Clients" data-id="element-62" data-mp="2mpz5bkbvb1iv">
      <div className="mx-auto w-full max-w-container px-5 sm:px-8" data-id="element-63" data-mp="2mnuyouml3oew">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between" data-id="element-64" data-mp="1q1jd1ghdie22">
          <SectionLabel data-id="element-65" data-mp="1u2d067mzrotw">Trusted by Brands</SectionLabel>
          <p className="text-sm text-muted" data-id="element-66" data-mp="1z0wnabdbn6nu">
            {clientLogos.length} shown · {remaining}+ more under NDA
          </p>
        </div>

        <ul className="mt-8 grid grid-cols-2 gap-4 border-t border-line pt-8 sm:grid-cols-2 lg:grid-cols-4" data-id="element-67" data-mp="23s4vx56tunzy">
          {clientLogos.map(client => <li key={client.name} className="group" data-id="element-68" data-mp="1basjo404v6wu">
              <div className="flex h-24 items-center justify-center border border-line bg-white px-6" data-id="element-69" data-mp="1b9hhg8mc677u">
                {client.src ? <img src={client.src} alt={`${client.name} logo`} className="h-full w-full object-contain opacity-70 grayscale transition duration-500 group-hover:opacity-100 group-hover:grayscale-0" loading="lazy" decoding="async" data-id="element-70" data-mp="1nlqpek5cj21y" /> : <span className="text-center font-display text-sm font-bold uppercase leading-tight tracking-[0.16em] text-[#09090e] transition-colors duration-500 group-hover:text-brand sm:text-base" data-id="element-71" data-mp="18url3lbjmzo6">
                    {client.name}
                  </span>}
              </div>
              {client.note ? <p className="label mt-3 text-muted/80" data-id="element-72" data-mp="2u9xbengku0hs">{client.note}</p> : null}
            </li>)}
        </ul>
      </div>
    </section>;
}